import request from "@/components/common/utils/request";

export function api_getWxQrCode_login(type) {
	return request({
		url: '/api/oauth2/wx/qrCode?type=' + type,
		method: 'get',
	})
}

export function api_qrBack_login(ticket) {
	return request({
		url: '/api/oauth2/wx/qrBack',
		method: 'get',
		params : {
			ticket : ticket
		}
	})
}